import { app } from '@/bootloader';

import { apolloProvider } from '@/plugins/GraphQL/Apollo/client';

app.use(apolloProvider);
